import { Controller } from "@hotwired/stimulus";

export default class UIToastController extends Controller {
  static targets = ["item"];

  connect() {
    if (this.element.role == "region" && this.element.dataset.auto != "false") {
      setTimeout(() => {
        this.open();
      }, 1000);
      this.close();
    }
  }

  open() {
    const toastElement = this.element.querySelector("[data-ui--toast-target='item']");
    this.element.dataset.state = "open";
    this.setHiddenState(this.element, false);
    this.showToast(toastElement);
  }

  close() {
    const toastElement = this.element.querySelector("[data-ui--toast-target='item']");
    this.element.dataset.state = "closed";
    this.setHiddenState(this.element, true);
    this.closeToast(toastElement);
  }

  showToast(el) {
    if (el) {
      el.dataset.state = "open";
      this.setHiddenState(el, false);
    }
  }

  closeToast(el) {
    if (el) {
      setTimeout(() => {
        el.dataset.state = "closed";
        this.setHiddenState(el, true);
      }, el.dataset.duration || 3000);
    }
  }

  trigger() {
    const idTarget = this.element.dataset.target;
    const toastContainer = document.querySelector(`${idTarget}`);
    if (!toastContainer) return;

    toastContainer.dataset.state = "open";
    this.setHiddenState(toastContainer, false);
    const toastElement = toastContainer.querySelector("[data-ui--toast-target='item']");
    this.showToast(toastElement);
    this.closeToast(toastElement);
  }

  openAll() {
    const toastElements = document.querySelectorAll(
      "[data-ui--toast-target='item']:not([data-visible='false'])",
    );
    toastElements.forEach((toastElement) => {
      this.showToast(toastElement);
    });
  }

  closeAll() {
    const toastElements = document.querySelectorAll("[data-ui--toast-target='item']");
    toastElements.forEach((toastElement) => {
      this.closeToast(toastElement);
    });
  }

  setHiddenState(element, shouldHide) {
    if (!element) return;

    if (shouldHide) {
      element.classList.add("tw-hidden");
    } else {
      element.classList.remove("tw-hidden");
    }
  }
}
